module.exports = __webpack_public_path__ + "static/img/official.9a5af74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/official.jpg
// module id = tJA5
// module chunks = 1